import { createFileRoute } from '@tanstack/react-router';

import { TickerSetupPage } from './-components/TickerSetupPage';

export const Route = createFileRoute('/_authenticated/tickers/new')({
    component: TickerSetupPage,
});
